import { TApplicationState } from '../../types/redux';

export function getIsAuthenticated(state: TApplicationState) {
  const user = state.userState.user;

  return user.isAuthenticated;
}
